export const fixedCacheKeys = {
  LOGIN: "user-login-post",
  SEND_OTP: "user-otp-post",
  VERIFY_OTP: "user-verify-post",
  LOGOUT: "user-verify-get",
  FORGOT_PASSWORD: "user-forgotPassword-post",
  RESET_PASSWORD: "user-resetPassword-post",
  DELETE_ACCOUNT: "user-deleteAccount-post",
  VERIFY_DELETE_ACCOUNT: "user-deleteAccount-verify",
  PRIVACY_POLICY: "user-privacyPolicy-get",
  EDIT_PROFILE: "user-profileData-Post",
  FILE_UPLOAD: "user-File-post",
  IMAGE_UPLOAD: "user-imageUpload-post",
  CHANGE_PASSWORD: "user-changePassword-post",
  DELETE_PROFILE: "user-deleteProfile-delete",
  ADD_META_DATA: "user-addMetaData-post",
  EDIT_META_DATA: "user-editMetaDta-put",
  EDIT_SITE_SETTING_DATA: "user-editSiteSettingData-put",
  EDIT_ANALYTICAL_DATA: "user-editAnalyticalData-put",
  ADD_SITE_DATA: "user-addSiteData-Post",
  ADD_ANALYTICAL_DATA: "user-addAnalyticalData-post",
  ADD_MAINTENANCE_DATA: "user-editMaintenanceData-post",
  EDIT_MAINTENANCE_DATA: "user-editMaintenanceData-put",
  DATE_TIME: "user-dateTime-Post",
  EDIT_DATE_TIME: "user-dateTime-put",
  ADD_SOCIAL_MEDIA_SDK: "user-addSocialMediaSdk-post",
  EDIT_SOCIAL_MEDIA_SDK: "user-editSocialMediaSdk-put",
  ADD_SOCIAL_MEDIA_LINK: "user-addSocialMediaLink-post",
  EDIT_SOCIAL_MEDIA_LINK: "user-editSocialMediaLink-put",
  CHANGE_STATUS: "user-changeStatus-post",
  ADD_SMTP_DETAILS: "user-addSmtpDetails-post",
  EDIT_SMTP_DETAILS: "user-editSmtpDetails-put",
  ADD_SMS_DETAILS: "user-addSmsDetails-post",
  EDIT_SMS_DETAILS: "user-editSmsDetails-put",
  NOTIFICATION_STATUS: "setting-notificationStatus-post",
  ADD_PAYMENT_DETAILS: "setting-paymentData-post",
  EDIT_PAYMENT_DETAILS: "setting-paymentData-put",
  TIMEZONE_LIST: "country-timezoneList-post",
  TIMEZONE_DELETE: "country-timeZoneData-delete",
  ADD_TIMEZONE: "country-addTimezone-post",
  TIMEZONE_CHANGE_STATUS: "timezone-changeStatus-post",
  COUNTRY_LIST: "country-list-post",
  COUNTRY_LIST_DELETE: "country-list-delete",
  COUNTRY_LIST_CHANGE_STATUS: "country-list-changeStatus-patch",
  ADD_COUNTRYLIST: "country-addCountryList-post",
  AMENITIES_LIST: "amenities-list-post",
  AMENITIES_LIST_DELETE: "amenities-list-delete",
  AMENITIES_LIST_CHANGE_STATUS: "amenities-list-changeStatus-patch",
  INDUSTRY_LIST: "industry-list-post",
  INDUSTRY_LIST_DELETE: "industry-list-delete",
  INDUSTRY_LIST_CHANGE_STATUS: "industry-list-changeStatus-patch",
  ADD_INDUSTRY_LIST: "industry-addIndustryList-post",
  EDIT_INDUSTRY_LIST: "industry-editIndustryList-put",
  ROLE_MASTER_LIST: "industry-role-post",
  ROLE_MASTER_DELETE: "industry-role-delete",
  ROLE_MASTER_LIST_CHANGE_STATUS: "industry-list-changeStatus-patch",
  ADD_ROLE_MASTER_LIST: "industry-addIndustryList-post",
  EDIT_ROLE_MASTER_LIST: "industry-editIndustryList-put",
  SUBSIDIARY_LIST: "subsidiary-list-post",
  SUBSIDIARY_LIST_DELETE: "subsidiary-list-delete",
  SUBSIDIARY_LIST_CHANGE_STATUS: "subsidiary-list-changeStatus-patch",
  ADD_SUBSIDIARY_LIST: "subsidiary-addSubsidiaryList-post",
  EDIT_SUBSIDIARY_LIST: "subsidiary-editSubsidiaryList-put",
  ADD_AMENITIES_LIST: "amenities-addAmenitiesList-post",
  LANGUAGE_MESSAGES: "language-messages-post",
  ADD_LANGUAGE_MESSAGES: "language-addMessages-post",
  LANGUAGE_LABEL: "language-label-post",
  ADD_LANGUAGE_LABEL: "language-addEditLabel-post",
  EDIT_LANGUAGE_LABEL: "language-editLabel-put",
  LANGUAGE_LIST: "country-language-post",
  LANGUAGE_LIST_CHANGE_STATUS: "language-list-changeStatus-patch",
  ADD_LANGUAGELIST: "country-addLanguageList-post",
  ADD_ROLE: "role-addRole-post",
  EDIT_ROLE: "role-editRole-put",
  ROLE_LIST: "role-roleList-post",
  CHANGE_ROLE: "role-changeRole-patch",
  DELETE_ROLE: "role-deleteRole-delete",
  USER_LIST: "role-usersList-get",
  EMAIL_TEMPLATES_LISTINGS: "email-emailTemlates-post",
  EMAIL_TEMPLATES_STATUS_CHANGE: "email-emailTemplatesStatus-post",
  EMAIL_TEMPLATES_DELETE: "email-emailTemplatesDelete-delete",
  EMAIL_TEMPLATES_ADD: "email-addEmailTemplates-post",
  EMAIL_TEMPLATES_EDIT: "email-editEmailTemplates-post",
  BLOG_CATEGORY_LISTING: "blog-blogCategoryListing-post",
  BLOG_CATEGORY_STATUS: "blog-blogCategoryStatus-post",
  BLOG_CATEGORY_DELETE: "blog-blogCategoryDelete-post",
  BLOG_CATEGORY_ADD: "blog-blogCategoryAdd-post",
  BLOG_CATEGORY_EDIT: "blog-blogCategoryEdit-post",
  BLOG_CATEGORY_LIST_DOWNLOAD: "blog-blogCategoriesDownload-get",
  BLOG_LIST: "blog-blogList-post",
  BLOG_ADD_LIST: "blog-blogAddEditList-post",
  BLOG_EDIT_LIST: "blog-blogEdit-post",
  BLOG_DELETE: "blog-blogDelete-delete",
  BLOG_PUBLISH: "blog-blogPublishStatusChange-patch",
  BLOG_LIST_DOWNLOAD: "blog-blogDownload-get",
  //faqCategory
  FAQ_CATEGORY_LISTING: "faq-faqCategoryListing-get",
  FAQ_CATEGORY_DELETE: "faq-faqCategoryDelete-delete",
  FAQ_CATEGORY_ADD: "faq-faqCategoryAdd-post",
  FAQ_CATEGORY_EDIT: "faq-faqCategoryEdit-put",
  FAQ_CATEGORY_DETAILS: "faq-faqCategoryDetails-get",
  FAQ_CATEGORY_STATUS_DETAILS: "faq-faqCategoryStatus-patch",
  //faq
  FAQ_LISTING: "faq-faqListing-get",
  FAQ_DELETE: "faq-faqDelete-delete",
  FAQ_ADD: "faq-faqAdd-post",
  FAQ_EDIT: "faq-faqEdit-put",
  FAQ_DETAILS: "faq-faqDetails-get",
  FAQ_STATUS_CHANGE: "faq-faqStatusChange-patch",
  //adminUser
  ADMIN_USER_DATA: "users-adminUsersData-post",
  ADD_ADMIN_USER_DATA: "users-addAdminUsersData-post",
  EDIT_ADMIN_USER_DATA: "users-editAdminUsersData-put",
  DELETE_ADMIN_USER_DATA: "users-deleteAdminUsersData-delete",
  ADMIN_USER_DETAILS_DOWNLOAD: "users-adminusersDownload-get",
  //User data
  USER_DATA: "users-UsersData-get",
  ADD_USER_DATA: "users-addUsersData-post",
  EDIT_USER_DATA: "users-editusersData-put",
  DELETE_USER_DATA: "users-deleteUsersData-delete",
  CHANGE_USER_STATUS: "users-changeUsersStatus-post",
  STATUS_ADMIN_USER_DATA: "users-statusAdminUsersData-post",
  USER_DETAILS_DOWNLOAD: "users-userDetailsDownload-get",
  //static page
  STATIC_PAGE_LISTING: "static-staticPageListing-post",
  STATIC_PAGE_CHANGE_STATUS: "static-staticPageChangeStatus-post",
  ADD_STATIC_PAGES: "static-addStaticPages-post",
  EDIT_STATIC_PAGES: "static-editStaticPages-post",
  DELETE_STATIC_PAGES: "static-deleteStaticPages-delete",
  STATIC_PAGE_LIST_DOWNLAOD: "static-staticpageDownload-get",
  //filter
  SAVE_FILTER_DATA: "filter-saveFilter-post",
  GET_FILTER_DATA: "filter-getFilter-post",
  DELETE_FILTER_DATA: "filter-deleteFilter-delete",
  SAVE_COLUMN_DATA: "column-saveColumn-post",
  GET_COLUMN_DATA: "column-getColumn-post",
  DELETE_COLUMN_DATA: "column-deleteColumn-delete",
  //support
  SUPPORT_LISTING: "support-getSupportList-get",
  SUPPORT_DELETE: "support-deleteSupport-delete",
  SUPPORT_STATUS: "support-ticketStatus-patch",
  SUPPORT_ADD_DATA: "support-addSupportData-post",
  SUPPORT_EDIT_DATA: "support-editReplyData-put",
  SUPPORT_REPLY_DELETE: "support-deleteReplyData-delete",

  //amenities
  EDIT_AMENITIES_LIST: "amenities-editAmenitiesList-put",
  ADD_AMENITIES_LIST: "amenities-addAmenitiesList-post",
  DELETE_AMENITIES_LIST: "amenities-deleteAmenitiesList-delete",
  AMENITIES_DETAILS: "amenities-amenitiesDetails-get",
  AMENITIES_LIST: "amenities-amenitiesList-get",
  AMENITIES_LIST_DOWNLOAD: "amenities-amenitiesListDownload-get",
  AMENITIES_LIST_CHANGE_STATUS: "amenities-amenitiesListChangeStatus-patch",
  //gemstone
  EDIT_GEMSTONE_TYPE: "gemstone-editGemstoneType-put",
  ADD_GEMSTONE_TYPE: "gemstone-addGemstoneType-post",
  DELETE_GEMSTONE_TYPE: "gemstone-deleteGemstoneType-delete",
  GEMSTONE_DETAILS: "gemstone-gemstoneDetails-get",
  GEMSTONE_LIST: "gemstone-gemstoneList-get",
  GEMSTONE_LIST_DOWNLOAD: "gemstone-gemstoneListDownload-get",
  GEMSTONE_LIST_CHANGE_STATUS: "gemstone-gemstoneListChangeStatus-patch",
  //property type
  PROPERTY_LISTING: "property-propertyListing-get",
  PROPERTY_SINGLE_DETAILS: "property-propertySingleDetails-get",
  EDIT_PROPERTY_TYPE: "propertyType-editPropertyType-put",
  ADD_PROPERTY_TYPE: "propertyType-addPropertyType-post",
  DELETE_PROPERTY_TYPE: "propertyType-deletePropertyType-delete",
  PROPERTY_TYPE_DETAILS: "propertyType-propertyTypeDetails-get",
  PROPERTY_TYPE_LIST: "propertyType-propertyTypeList-get",
  PROPERTY_TYPE_LIST_DOWNLOAD: "propertyType-propertyTypeListDownload-get",
  PROPERTY_TYPE_LIST_CHANGE_STATUS:
    "propertyType-propertyTypeListChangeStatus-patch",
  PROPERTY_GENERAL_OPTIONS: "property-propertyGeneralOptions-get",
  //individual user
  INDIVIDUAL_USER_DETAILS: "users-individualUserDetails-get",
  INDIVIDUAL_USER_DETAILS_CATEGORY: "users-individualUserDetailsCategory-get",
  INDIVIDUAL_USER_INCOME_INFORMATION_DOCUMENTS: "users-incomeInformation-get",
  INDIVIDUAL_USER_DETAILS_DOCUMENTS: "users-individualUserDetailsDocuments-get",
  INDIVIDUAL_USER_INVESTMENTS: "users-individualUserInvestmentsDocuments-get",
  INDIVIDUAL_USER_DEPOSITS: "users-individualUserDepositsDocuments-get",
  INDIVIDUAL_USER_WITHDRAWALS: "users-individualUserWithdrawalsDocuments-get",
  INDIVIDUAL_USER_BANK_ACCOUNTS:
    "users-individualUserBankAccountsDocuments-get",
  INDIVIDUAL_USER_RISKMETER: "users-individualUserRiskMeter-get",
  INDIVIDUAL_USER_RETURNS: "users-individualUserReturns-get",
  INDIVIDUAL_USER_RETURNS_STATISTICS:
    "users-individualUserReturnsStatistics-get",
  INDIVIDUAL_USER_TIMELINE: "users-individualUserTimeline-get",
  INDIVIDUAL_USER_PERSONAL_DETAILS: "users-individualUserPersonalDetails-get",
  INDIVIDUAL_USER_PERSONAL_SINGLE_DETAILS:
    "users-individualUserPersonalSingleDetails-get",
  INDIVIDUAL_USER_KYC_HISTORY_LISTING:
    "users-individualUserKYCHistoryListing-get",
  INDIVIDUAL_USER_KYC_STATUS_UPDATE:
    "users-individualUserKYCStatusUpdate-patch",
  //configuration
  CONFIGURATION_LIST: "configuration-configurationList-get",
  CONFIGURATION_SAVE: "configuration-configurationSave-post",
  //deposits
  DEPOSITS_LIST: "deposits-depositsList-get",
  EDIT_DEPOSITS_LIST: "deposits-editDepositsList-put",
  DEPOSITS_LIST_CHANGE_STATUS: "deposits-depositsListChangeStatus-patch",
  DEPOSITS_DETAILS: "deposits-depositsDetails-get",
  DEPOSITS_LIST_DELETE: "deposits-depositsListDelete-delete",
  ADD_DEPOSITS_LIST: "deposits-addDepositsList-post",
  DEPOSITS_LIST_DOWNLOAD: "deposits-depositsListDownload-get",
  //withdrawal
  WITHDRAWAL_LIST: "withdrawal-withdrawalList-get",
  EDIT_WITHDRAWAL_LIST: "withdrawal-editWithdrawalList-put",
  WITHDRAWAL_LIST_CHANGE_STATUS: "withdrawal-withdrawalListChangeStatus-patch",
  WITHDRAWAL_DETAILS: "withdrawal-withdrawalDetails-get",
  WITHDRAWAL_LIST_DELETE: "withdrawal-withdrawalListDelete-delete",
  ADD_WITHDRAWAL_LIST: "withdrawal-addWithdrawalList-post",
  WITHDRAWAL_LIST_DOWNLOAD: "withdrawal-withdrawalListDownload-get",
  //exitwindow
  EXIT_WINDOW_LIST: "exitwindow-exitWindowList-get",
  EXIT_WINDOW_PROPERTY_DETAILS: "exitwindow-exitWindowPropertyDetails-get",
  EXIT_WINDOW_SELL_REQUESTS_LIST: "exitwindow-exitWindowSellRequestsList-get",
  EDIT_EXIT_WINDOW_LIST: "exitwindow-editExitWindowList-put",
  EXIT_WINDOW_LIST_CHANGE_STATUS: "exitwindow-exitWindowListChangeStatus-patch",
  EXIT_WINDOW_DETAILS: "exitwindow-exitWindowDetails-get",
  EXIT_WINDOW_LIST_DELETE: "exitwindow-exitWindowListDelete-delete",
  ADD_EXIT_WINDOW_LIST: "exitwindow-addExitWindowList-post",
  EXIT_WINDOW_PURCHASE_REQUESTS_LIST:
    "exitwindow-exitWindowPurchaseRequestsList-get",
  EXIT_WINDOW_SELLER_DETAILS: "exitwindow-exitWindowSellerDetails-get",
  EXIT_WINDOW_LIST_DOWNLOAD: "exitwindow-exitWindowListDownload-get",
  EXIT_WINDOW_SELL_REQUESTS_LIST_DOWNLOAD:
    "exitwindow-exitWindowSellRequestsListDownload-get",
  EXIT_WINDOW_PURCHASE_REQUESTS_LIST_DOWNLOAD:
    "exitwindow-exitWindowPurchaseRequestsListDownload-get",
  ARCHIVED_USER: "archived-user-listing-get",
  //saleProceed
  SALE_PROCEED_LIST: "saleProceed-saleProceedList-get",
  EDIT_SALE_PROCEED_LIST: "saleProceed-editSaleProceedList-put",
  SALE_PROCEED_LIST_CHANGE_STATUS:
    "saleProceed-saleProceedListChangeStatus-patch",
  SALE_PROCEED_DETAILS: "saleProceed-saleProceedDetails-get",
  SALE_PROCEED_LIST_DELETE: "saleProceed-saleProceedListDelete-delete",
  ADD_SALE_PROCEED_LIST: "saleProceed-addSaleProceedList-post",
  SALE_PROCEED_INVESTMENT_LIST: "saleProceed-saleProceedInvestmentList-get",
  PROPERTY_SALE_PROCEED_OPTIONS: "property-propertySaleProceedOptions-get",
  //invesments
  PROPERTY_INVESMENTS_LIST: "property-propertyInvesmentsList-get",
  EDIT_PROPERTY_INVESMENTS_LIST: "property-editPropertyInvesmentsList-put",
  PROPERTY_INVESMENTS_LIST_CHANGE_STATUS:
    "property-propertyInvesmentsListChangeStatus-patch",
  PROPERTY_INVESMENTS_DETAILS: "property-propertyInvesmentsDetails-get",
  PROPERTY_INVESMENTS_LIST_DELETE:
    "property-propertyInvesmentsListDelete-delete",
  ADD_PROPERTY_INVESMENTS_LIST: "property-addPropertyInvesmentsList-post",
  PROPERTY_INVESMENT_SUMMARY_LIST: "property-propertyInvesmentSummaryList-get",
  PROPERTY_INVESTMENT_UPDATE_DETAILS:
    "property-propertyInvestmentUpdateDetails-get",
  PROPERTY_INVESTMENT_UPDATE_STATUS:
    "property-propertyInvestmentUpdateStatus-patch",
  //Property detailks
  PROPERTY_INVESTMENT_LIST: "property-propertyInvestmentList-get",
  PROPERTY_DIVIDEND_LIST: "property-propertyDividendList-get",
  PROPERTY_SALE_PROCEED_LIST: "property-propertySaleProceedList-get",
  PROPERTY_INVESMENTS_DOWNLOAD: "property-propertyInvesmentsDownload-get",
  //transaction report
  TRANSACTION_REPORT: "property-propertySaleProceedList-get",
  //business user
  CHANGE_BUSINESS_USER_STATUS: "users-changeBusinessUserStatus-post",
  EXIT_WINDOW_STAKE_DETAILS: "exitwindow-exitWindowStakeDetails-get",
  ADD_EXIT_WINDOW_PURCHASE_REQUESTS:
    "exitwindow-addExitWindowPurchaseRequests-post",
  //saleProceedNotification
  SALE_PROCEED_NOTIFICATION_LIST: "saleProceed-saleProceedNotificationList-get",
  SALE_PROCEED_NOTIFICATION_DETAILS:
    "saleProceed-saleProceedNotificationDetails-get",
  ADD_SALE_PROCEED_NOTIFICATION_LIST:
    "saleProceed-addSaleProceedNotificationList-post",
  SALE_PROCEED_LIST_DOWNLOAD: "saleProceed-saleProceedListDownload-get",
  SALE_PROCEED_NOTIFICATION_LIST_DOWNLOAD:
    "saleProceed-saleProceedNotificationListDownload-get",
  //rewards
  REWARDS_LIST: "rewards-rewardsList-get",
  REWARDS_LIST_CHANGE_STATUS: "rewards-rewardsListChangeStatus-patch",
  REWARDS_DETAILS: "rewards-rewardsDetails-get",
  REWARDS_LIST_DELETE: "rewards-rewardsListDelete-delete",
  ADD_REWARDS_LIST: "rewards-addRewardsList-post",
  REWARDS_DETAILS_LIST: "rewards-rewardsDetailsList-get",
  REWARDS_LIST_DOWNLOAD: "rewards-rewardsListDownload-get",
  REWARDS_PAYOUT_DOWNLOAD: "rewards-rewardsPayoutDownload-get",
  REWARDS_REFFERED_DOWNLOAD: "rewards-rewardsReferredDownload-get",
  //property dividend
  PROPERTY_DIVIDEND_DOWNLOAD: "property-propertyDividendDownload-get",
  ADD_PROPERTY_DIVIDEND_LIST: "property-addPropertyDividendList-post",
  EDIT_PROPERTY_DIVIDEND_LIST: "property-editPropertyDividendList-put",
  PROPERTY_DIVIDEND_LIST_CHANGE_STATUS:
    "property-propertyDividendListChangeStatus-patch",
  PROPERTY_DIVIDEND_LIST_DELETE: "property-propertyDividendListDelete-delete",
  PROPERTY_DIVIDEND_DETAILS: "property-propertyDividendDetails-get",
  PROPERTY_DIVIDEND_USER_LIST: "property-propertyDividendUserList-get",
  UPDATE_BUSINESS_CUSTOM_USER_DOCUMENT:
    "users-updateBusinessCustomUserDocument-put",
  TERMS_AND_CONDITIONS: "terms-and-conditions-get",
};
